var config = {
  supportEmail: 'support@parsebiosciences.com',
  pipelineVersionToRerunQC: 2,
  workerVersion: 4 // needs to match workerVersion in API
};
export default config;